<template>
  <div id="dashboard-design">
    <h1>Team Designs</h1>

    <TemplateChooser :no-edit="!isAdmin" />
    <ProductTemplatePreview @edit="onEditTemplate" :edit-button="isAdmin" />
    <ChooseProduct :edit-button="isAdmin" />

    <div id="dashboard-actions">
      <StartOrderButton/>
      <b-button to="design/new"
        v-if="isAdmin"
        variant="primary"
        >
        <span v-if="productTemplateDesignId">Re-upload Design</span>
        <span v-else>Upload New Design</span>
      </b-button>
    </div>

     <b-alert variant="danger" id="error-alert" :show="!!uploadError" class="error">{{uploadError}}</b-alert>

     <!-- debugging tool, turn on debugTools to see it -->
    <span
        style="text-align: left; font-size: small; border: 3px dashed blue; padding: 3px;"
        v-if="flags.debugTools"
        >
      <button  @click="resetDesign">Reset PDT</button>
      <button  @click="deleteDesign">Delete PDT</button>
    </span>

  </div>
</template>

<style scoped lang="scss">
#dashboard-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 504px;
  & > * {
    margin: 1em 0;
  }
}

#dashboard-design {
  position: relative;
  h1 {
    margin-top: 0;
    font-size: 2em;
  }
}

button.btn.btn-default {
  line-height: 20px;

  // Match PdfUploader height
  height: 48px;
}

#error-alert {
  max-width: 504px;
  border-radius: 2px;
}

@media (max-width: 450px) {
  #dashboard-actions {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
  }
  .btn-default {
    width: 225px;
  }
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import ChooseProduct from "./ChooseProduct";
import {designUploadSuccess, designUploadError} from '@/lib/track/events';
export default {
  data() {
    return {
      uploadError: null
    };
  },
  components: { ChooseProduct },
  computed: {
    ...mapGetters([
      "productTemplate",
      "productTemplateDesignId",
      "flags",
      "isAdmin"
    ])
  },
  mounted() {
    if (!this.productTemplateDesignId) {
      this.$router.push('design/new');
    }
  },
  methods: {
    ...mapActions([
      "updateProductTemplate",
      "deleteProductTemplates"
    ]),
    onError(message) {
      designUploadError(message);
      this.uploadError = message;
    },
    onUpload() {
      designUploadSuccess();
    },
    onEditTemplate(...args) {
      console.log('onEditTemplate', args);
      this.$router.push({name: 'Editor', params: {id: this.productTemplateDesignId}});
    },
    resetDesign() {
      this.updateProductTemplate({template: null});
    },
    deleteDesign() {
      this.deleteProductTemplates();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/design/DesignMain.vue